 export const API_BASE_URL = 'https://backend.chseexpress.com';
//export const API_BASE_URL = 'https://demo.chseexpress.com';

 export const RAZORPAY_KEY_ID = 'rzp_live_NvEkuW14Ie22zW';

//export const RAZORPAY_KEY_ID = 'rzp_test_SBEQPc4smmOY2F';
